import { Document } from './../index';

export class EquipmentDocuments {
    public EquipmentId: number;
    public Documents: Document[] = [];
}
